/**
 * ABA CALENDÁRIO
 *
 * Esta aba é reservada ao calendário de agenda em tela cheia.
 *
 * Campos `date`, `datetime` e `period` NÃO pertencem aqui. Eles são campos de
 * formulário e ficam documentados na aba Formulários.
 */
const calendarLayout = [];

export default calendarLayout;
